var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 20.75H6.5C4.082 20.75 2.75 19.418 2.75 17V8C2.75 5.582 4.082 4.25 6.5 4.25H18.5C20.918 4.25 22.25 5.582 22.25 8V17C22.25 19.418 20.918 20.75 18.5 20.75ZM6.5 5.75C4.923 5.75 4.25 6.423 4.25 8V17C4.25 18.577 4.923 19.25 6.5 19.25H18.5C20.077 19.25 20.75 18.577 20.75 17V8C20.75 6.423 20.077 5.75 18.5 5.75H6.5ZM13.5291 13.179L18.4409 9.60699C18.7759 9.36399 18.85 8.89401 18.606 8.55901C18.363 8.22501 17.8951 8.149 17.5581 8.394L12.646 11.966C12.558 12.03 12.441 12.03 12.353 11.966L7.44092 8.394C7.10292 8.149 6.63607 8.22601 6.39307 8.55901C6.14907 8.89401 6.22311 9.36299 6.55811 9.60699L11.47 13.18C11.778 13.404 12.139 13.515 12.499 13.515C12.859 13.515 13.2221 13.403 13.5291 13.179Z",
    fill: "#B1B5C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.65985c991b8cc48aa7413ecc6ee11c6f.svg";
export { ForwardRef as ReactComponent };